export default [
   {
      "name":"កាតាឡង់",
      "language":"ca",
      "emoji":"🇪🇸"
   },
   {
      "name":"កាន់ណាដា",
      "language":"kn",
      "emoji":"🇮🇳"
   },
   {
      "name":"កាហ្សាក់ស្តង់",
      "language":"kk",
      "emoji":"🇰🇿"
   },
   {
      "name":"កូរ៉េ",
      "language":"ko",
      "emoji":"🇰🇷"
   },
   {
      "name":"កូសីកា",
      "language":"co",
      "emoji":"🇫🇷"
   },
   {
      "name":"កេជ័រ",
      "language":"qu",
      "emoji":"🇵🇪"
   },
   {
      "name":"ក្រិក",
      "language":"el",
      "emoji":"🇬🇷"
   },
   {
      "name":"ក្រូអាត",
      "language":"hr",
      "emoji":"🇭🇷"
   },
   {
      "name":"ក្រេអូលី​ហៃទី",
      "language":"ht",
      "emoji":"🇭🇹"
   },
   {
      "name":"ខ្មែរ",
      "language":"km",
      "emoji":"🇰🇭"
   },
   {
      "name":"គីនយ៉ារវ៉ាន់ដា",
      "language":"rw",
      "emoji":"🇷🇼"
   },
   {
      "name":"គីស៊ី",
      "language":"ky",
      "emoji":"🇰🇬"
   },
   {
      "name":"គុនកានី",
      "language":"gom",
      "emoji":"🇮🇳"
   },
   {
      "name":"គ្រីអូ",
      "language":"kri",
      "emoji":"🇸🇱"
   },
   {
      "name":"ឃើឌីស (គូម៉ាន់ជី)",
      "language":"ku",
      "emoji":"🇰🇼"
   },
   {
      "name":"ឃើឌីស (សូរ៉ានី)",
      "language":"ckb",
      "emoji":"🇮🇶"
   },
   {
      "name":"ចិន (អក្សរកាត់)",
      "language":"zh",
      "emoji":"🇨🇳"
   },
   {
      "name":"ចិន (អក្សរ​ពេញ)",
      "language":"zh-tw",
      "emoji":"🇹🇼"
   },
   {
      "name":"ឆេក",
      "language":"cs",
      "emoji":"🇨🇿"
   },
   {
      "name":"ជប៉ុន",
      "language":"ja",
      "emoji":"🇯🇵"
   },
   {
      "name":"ជ្វា",
      "language":"jw",
      "emoji":"🇮🇩"
   },
   {
      "name":"ឈិចិវា",
      "language":"ny",
      "emoji":"🇲🇼"
   },
   {
      "name":"ដាណឺម៉ាក",
      "language":"da",
      "emoji":"🇩🇰"
   },
   {
      "name":"ដូគ្រី",
      "language":"doi",
      "emoji":"🇮🇳"
   },
   {
      "name":"ដៀវីហ៊ី",
      "language":"dv",
      "emoji":"🇲🇻"
   },
   {
      "name":"តាដហ្ស៊ីគីស្តង់",
      "language":"tg",
      "emoji":"🇹🇯"
   },
   {
      "name":"តាតា",
      "language":"tt",
      "emoji":"🇹🇲"
   },
   {
      "name":"តាមីល",
      "language":"ta",
      "emoji":"🇮🇳"
   },
   {
      "name":"តួកគី",
      "language":"tr",
      "emoji":"🇹🇷"
   },
   {
      "name":"តេលុគុ",
      "language":"te",
      "emoji":"🇮🇳"
   },
   {
      "name":"ត្វី",
      "language":"ak",
      "emoji":"🇬🇭"
   },
   {
      "name":"ថៃ",
      "language":"th",
      "emoji":"🇹🇭"
   },
   {
      "name":"ទីរិនយា",
      "language":"ti",
      "emoji":"🇪🇷"
   },
   {
      "name":"ទួគមេនីស្តង់",
      "language":"tk",
      "emoji":"🇹🇲"
   },
   {
      "name":"ន័រវែស",
      "language":"no",
      "emoji":"🇳🇴"
   },
   {
      "name":"នេប៉ាល់",
      "language":"ne",
      "emoji":"🇳🇵"
   },
   {
      "name":"បង់ក្លាដែស",
      "language":"bn",
      "emoji":"🇧🇩"
   },
   {
      "name":"ប៉ាម​បារ៉ា",
      "language":"bm",
      "emoji":"🇲🇱"
   },
   {
      "name":"បារាំង",
      "language":"fr",
      "emoji":"🇫🇷"
   },
   {
      "name":"បាស្កេ",
      "language":"eu",
      "emoji":"🇪🇸"
   },
   {
      "name":"បាស្តូ",
      "language":"ps",
      "emoji":"🇦🇫"
   },
   {
      "name":"បឹនជាពិ",
      "language":"pa",
      "emoji":"🇮🇳"
   },
   {
      "name":"ប៊ុលហ្ការី",
      "language":"bg",
      "emoji":"🇧🇬"
   },
   {
      "name":"បូជផូរី",
      "language":"bho",
      "emoji":"🇮🇳"
   },
   {
      "name":"បូស្នី",
      "language":"bs",
      "emoji":"🇧🇦"
   },
   {
      "name":"ប៉ូឡូញ",
      "language":"pl",
      "emoji":"🇵🇱"
   },
   {
      "name":"បេឡារុស្ស",
      "language":"be",
      "emoji":"🇧🇾"
   },
   {
      "name":"ព័រទុយហ្កាល់",
      "language":"pt",
      "emoji":"🇵🇹"
   },
   {
      "name":"ភាសាសំស្ក្រឹត",
      "language":"sa",
      "emoji":"🇮🇳"
   },
   {
      "name":"ភឺសៀន",
      "language":"fa",
      "emoji":"🇮🇷"
   },
   {
      "name":"ម៉ាដាហ្កាសការ",
      "language":"mg",
      "emoji":"🇲🇬"
   },
   {
      "name":"ម៉ារាទី",
      "language":"mr",
      "emoji":"🇮🇳"
   },
   {
      "name":"ម៉ាល់តា",
      "language":"mt",
      "emoji":"🇲🇹"
   },
   {
      "name":"ម៉ាសេដូនី",
      "language":"mk",
      "emoji":"🇲🇰"
   },
   {
      "name":"ម៉ាឡាយ៉ាឡាម",
      "language":"ml",
      "emoji":"🇮🇳"
   },
   {
      "name":"ម៉ាឡេស៊ី",
      "language":"ms",
      "emoji":"🇲🇾"
   },
   {
      "name":"មីយ៉ាន់ម៉ា (ភូមា)",
      "language":"my",
      "emoji":"🇲🇲"
   },
   {
      "name":"មីហ្សូ",
      "language":"lus",
      "emoji":"🇮🇳"
   },
   {
      "name":"ម៉ុង",
      "language":"hmn",
      "emoji":"🇨🇳"
   },
   {
      "name":"ម៉ុងហ្គោលី",
      "language":"mn",
      "emoji":"🇲🇳"
   },
   {
      "name":"ម៉េតេឡុន (ម៉ានីពូរី)",
      "language":"mni-mtei",
      "emoji":"🇮🇳"
   },
   {
      "name":"ម៉ៃធីលី",
      "language":"mai",
      "emoji":"🇮🇳"
   },
   {
      "name":"ម៉ោរី",
      "language":"mi",
      "emoji":"🇳🇿"
   },
   {
      "name":"យីឌីស",
      "language":"yi",
      "emoji":"🇮🇱"
   },
   {
      "name":"យូរុយបា",
      "language":"yo",
      "emoji":"🇳🇬"
   },
   {
      "name":"រុស្ស៊ី",
      "language":"ru",
      "emoji":"🇷🇺"
   },
   {
      "name":"រូម៉ានី",
      "language":"ro",
      "emoji":"🇷🇴"
   },
   {
      "name":"លីទុយអានី",
      "language":"lt",
      "emoji":"🇱🇹"
   },
   {
      "name":"លីនហ្កាឡា",
      "language":"ln",
      "emoji":"🇨🇩"
   },
   {
      "name":"លុចហ្សំបួរ",
      "language":"lb",
      "emoji":"🇱🇺"
   },
   {
      "name":"វៀតណាម",
      "language":"vi",
      "emoji":"🇻🇳"
   },
   {
      "name":"វេល",
      "language":"cy",
      "emoji":"🏴󠁧󠁢󠁷󠁬󠁳󠁿"
   },
   {
      "name":"សាមូអា",
      "language":"sm",
      "emoji":"🇼🇸"
   },
   {
      "name":"ស៊ី​ន​ហា​ឡា",
      "language":"si",
      "emoji":"🇱🇰"
   },
   {
      "name":"ស៊ីន្តី",
      "language":"sd",
      "emoji":"🇵🇰"
   },
   {
      "name":"សឹតសង់ហ្កា",
      "language":"ts",
      "emoji":"🇿🇦"
   },
   {
      "name":"សឺប៊ូអាណូ",
      "language":"ceb",
      "emoji":"🇵🇭"
   },
   {
      "name":"ស៊ុយអែត",
      "language":"sv",
      "emoji":"🇸🇪"
   },
   {
      "name":"ស៊ូដង់",
      "language":"su",
      "emoji":"🇮🇩"
   },
   {
      "name":"សូណា",
      "language":"sn",
      "emoji":"🇿🇼"
   },
   {
      "name":"សូធូ​ខាង​ជើង",
      "language":"nso",
      "emoji":"🇿🇦"
   },
   {
      "name":"សូម៉ាលី",
      "language":"so",
      "emoji":"🇸🇴"
   },
   {
      "name":"សូលូ",
      "language":"zu",
      "emoji":"🇿🇦"
   },
   {
      "name":"សេសូធូ",
      "language":"st",
      "emoji":"🇱🇸"
   },
   {
      "name":"ស៊ែប៊ី",
      "language":"sr",
      "emoji":"🇷🇸"
   },
   {
      "name":"ស្កុតហ្គាលីក",
      "language":"gd",
      "emoji":"🏴󠁧󠁢󠁳󠁣󠁴󠁿"
   },
   {
      "name":"ស្លូវ៉ាគី",
      "language":"sk",
      "emoji":"🇸🇰"
   },
   {
      "name":"ស្លូវ៉ានី",
      "language":"sl",
      "emoji":"🇸🇮"
   },
   {
      "name":"ស្វាហ៊ីលី",
      "language":"sw",
      "emoji":"🇹🇿"
   },
   {
      "name":"ហាវ៉ៃ",
      "language":"haw",
      "emoji":"🇺🇸"
   },
   {
      "name":"ហិណ្ឌី",
      "language":"hi",
      "emoji":"🇮🇳"
   },
   {
      "name":"ហុងគ្រី",
      "language":"hu",
      "emoji":"🇭🇺"
   },
   {
      "name":"ហូសា",
      "language":"ha",
      "emoji":"🇳🇬"
   },
   {
      "name":"ហូ​ស្សា",
      "language":"xh",
      "emoji":"🇿🇦"
   },
   {
      "name":"ហូឡង់",
      "language":"nl",
      "emoji":"🇳🇱"
   },
   {
      "name":"ហ្កានដា",
      "language":"lg",
      "emoji":"🇺🇬"
   },
   {
      "name":"ហ្កុយ៉ារាទី",
      "language":"gu",
      "emoji":"🇮🇳"
   },
   {
      "name":"ហ្គាលីស្យាន",
      "language":"gl",
      "emoji":"🇪🇸"
   },
   {
      "name":"ហ្គូរ៉ានី",
      "language":"gn",
      "emoji":"🇵🇾"
   },
   {
      "name":"ហ្រីសង់",
      "language":"fy",
      "emoji":"🇳🇱"
   },
   {
      "name":"ហ្វីលីពីន",
      "language":"tl",
      "emoji":"🇵🇭"
   },
   {
      "name":"ហ្វាំងឡង់",
      "language":"fi",
      "emoji":"🇫🇮"
   },
   {
      "name":"ហ្សក​ហ្ស៊ី",
      "language":"ka",
      "emoji":"🇬🇪"
   },
   {
      "name":"ឡាតវីយ៉ា",
      "language":"lv",
      "emoji":"🇱🇻"
   },
   {
      "name":"ឡាតាំង",
      "language":"la",
      "emoji":"🏴"
   },
   {
      "name":"ឡាវ",
      "language":"lo",
      "emoji":"🇱🇦"
   },
   {
      "name":"អង់គ្លេស",
      "language":"en",
      "emoji":"🇬🇧"
   },
   {
      "name":"អាមហារីច",
      "language":"am",
      "emoji":"🇪🇹"
   },
   {
      "name":"អារមេនី",
      "language":"hy",
      "emoji":"🇦🇲"
   },
   {
      "name":"អារ៉ាប់",
      "language":"ar",
      "emoji":"🇸🇦"
   },
   {
      "name":"អាល់បានី",
      "language":"sq",
      "emoji":"🇦🇱"
   },
   {
      "name":"អាល្លឺម៉ង់",
      "language":"de",
      "emoji":"🇩🇪"
   },
   {
      "name":"អាសាមីស",
      "language":"as",
      "emoji":"🇮🇳"
   },
   {
      "name":"អាហ្វ្រិក",
      "language":"af",
      "emoji":"🇿🇦"
   },
   {
      "name":"អាហ៊្សែបៃហ្សង់",
      "language":"az",
      "emoji":"🇦🇿"
   },
   {
      "name":"ឥណ្ឌូណេស៊ី",
      "language":"id",
      "emoji":"🇮🇩"
   },
   {
      "name":"អ៊ីកបូ",
      "language":"ig",
      "emoji":"🇳🇬"
   },
   {
      "name":"អ៊ីតាលី",
      "language":"it",
      "emoji":"🇮🇹"
   },
   {
      "name":"អ៊ីស្រាអែល",
      "language":"iw",
      "emoji":"🇮🇱"
   },
   {
      "name":"អ៊ីស្លង់",
      "language":"is",
      "emoji":"🇮🇸"
   },
   {
      "name":"អ៊ីឡូកូ",
      "language":"ilo",
      "emoji":"🇵🇭"
   },
   {
      "name":"អ៊ុយក្រែន",
      "language":"uk",
      "emoji":"🇺🇦"
   },
   {
      "name":"អ៊ុយហ្គួរ",
      "language":"ug",
      "emoji":"🇨🇳"
   },
   {
      "name":"អុរុមុ",
      "language":"om",
      "emoji":"🇪🇹"
   },
   {
      "name":"អូឌៀ (អូរីយា)",
      "language":"or",
      "emoji":"🇮🇳"
   },
   {
      "name":"អ៊ូរឌូ",
      "language":"ur",
      "emoji":"🇵🇰"
   },
   {
      "name":"អ៊ូហ្សបេគីស្តង់",
      "language":"uz",
      "emoji":"🇺🇿"
   },
   {
      "name":"អៀរឡង់",
      "language":"ga",
      "emoji":"🇮🇪"
   },
   {
      "name":"អេវី",
      "language":"ee",
      "emoji":"🇹🇬"
   },
   {
      "name":"អេស្តូនី",
      "language":"et",
      "emoji":"🇪🇪"
   },
   {
      "name":"អេស្ប៉ាញ",
      "language":"es",
      "emoji":"🇪🇸"
   },
   {
      "name":"អេស្ពេរ៉ាន់តូ",
      "language":"eo",
      "emoji":"🌍"
   },
   {
      "name":"អៃម៉ារ៉ា",
      "language":"ay",
      "emoji":"🇧🇴"
   },
   {
      "name":"អ៊ីស្រាអែល",
      "language":"he",
      "emoji":"🇮🇱"
   },
   {
      "name":"ជ្វា",
      "language":"jv",
      "emoji":"🇮🇩"
   },
   {
      "name":"ចិន (អក្សរកាត់)",
      "language":"zh-cn",
      "emoji":"🇨🇳"
   }
]